import React, { Component } from 'react'
import Radium from 'radium';
import Row from './table/row'
import Cell from './table/cell'
import Header from './table/header'
import PicFSUpload from '../../Common/picFSUpload';
import { semanticColors } from '../../Globals/styles';

const propTypes = {}

const defaultProps = {}

class Apvs extends Component {
    constructor(props) {
        super(props)
        this.state = {
            width: [
                '50%',
                '40%',
                '10%',
            ],
            init: props.rows.slice(0)
        }
    }
    renderHeader = () => {
        return (
            <Row
            >
                <Header
                    content={'Navn'}
                    style={{ width: this.state.width[0] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
                <Header
                    content={'Fil'}
                    style={{ width: this.state.width[1] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
                <Header
                    content={''}
                    style={{ width: this.state.width[2] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
            </Row>
        )
    }
    handleLongFileName = (fileName) => {
        if (fileName.length > 40) {
            return fileName.substring(0, 20) + '...' + fileName.substring(fileName.length - 15, fileName.length);
        }
        return fileName;
    }
    renderContent = (r, index) => {
        let background = index % 2 === 0 ? semanticColors.mainBackground2 : semanticColors.primaryLight
        let fileName = ''
        if (r.document) {
            fileName = this.handleLongFileName(r.document.name)
        }
        return (
            <Row
                key={index}
            >
                <Cell
                    onChange={(value) => this.props.update('name', value, index)}
                    content={r.name}
                    style={{ width: this.state.width[0] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                {r.document ?
                    <Cell
                        content={fileName}
                        style={{ width: this.state.width[1] }}
                        inputStyle={{
                            backgroundColor: background,
                            textAlign: 'center',
                        }}
                    >
                        <div style={{ position: 'relative' }}>
                            <div style={{ position: 'absolute', bottom: 9, left: 5, width: 20 }}>
                                <i
                                    style={{ paddingTop: 12, cursor: 'pointer', width: 20 }}
                                    className="fa fa-search"
                                    aria-hidden="true"
                                    onClick={() => this.props.openPdf(r.document, 'click')}
                                    onTouchEnd={() => this.props.openPdf(r.document, 'touch')}
                                />
                            </div>
                            <div style={{ position: 'absolute', bottom: 8, left: 35, width: 20 }}>
                                <i
                                    style={{ paddingTop: 12, cursor: 'pointer', width: 20 }}
                                    className="fa fa-times-circle"
                                    aria-hidden="true"
                                    onClick={() => this.props.updateApv(null, index)}
                                />
                            </div>
                        </div>
                    </Cell> :
                    <div
                        style={{
                            width: this.state.width[1],
                            backgroundColor: background,
                            textAlign: 'center',
                            flexGrow: 0,
                            flexShrink: 0,
                            verticalAlign: 'top',
                        }}

                    >
                        <PicFSUpload
                            className="waves-btn"
                            accept="application/pdf,image/*"
                            style={{ height: 35 }}
                            onFilesSelected={files => {
                                var reader = new FileReader();
                                reader.onload = (function (f) {
                                    return function (e) {
                                        this.props.updateApv({ fileUrl: e.target.result.split(',')[1], name: f.name }, index)
                                    };
                                })(files[0]).bind(this);

                                // Read in the image file as a data URL.
                                reader.readAsDataURL(files[0]);
                            }}
                            multiple={false}>
                            <div
                                style={{ display: 'flex', justifyContent: 'center' }}>
                                <i
                                    className="fa fa-file-o"
                                    aria-hidden="true"
                                    style={{ paddingTop: 11, cursor: 'pointer' }}
                                >
                                </i>
                                <div
                                    style={{ 'marginTop': '8px', paddingLeft: 5 }}>
                                    Upload fil
                                </div>
                            </div>
                        </PicFSUpload>
                    </div>
                }
                <div style={{ width: this.state.width[1], backgroundColor: background }}>
                    {r.changed ?
                        <div style={{ backgroundColor: background, position: 'relative', color: '#777777' }}>
                            <div
                                style={{ position: 'absolute', left: 50, width: 20, cursor: 'pointer' }}
                                onClick={() => this.props.save(index)}
                            >
                                <i
                                    key="floppyIcon"
                                    aria-hidden="true"
                                    className="waves-icon fa fa-floppy-o"
                                    style={{ fontSize: 23, display: 'block' }}
                                />
                                <div style={styles.label}>Gem</div>
                            </div>
                            <div
                                style={{ cursor: 'pointer', width: 20 }}
                                onClick={() => this.props.cancel(index)}
                            >
                                <i
                                    key="floppyIcon2"
                                    className="waves-icon fa fa-ban"
                                    aria-hidden="true"
                                    style={{ fontSize: 23, display: 'block' }}
                                />
                                <div style={[styles.label, { right: 5 }]}>Annuller</div>
                            </div>
                        </div>
                        : null}
                </div>

            </Row>
        )
    }
    render() {
        let rows = this.props.rows.map((row, index) => {
            return this.renderContent(row, index)
        })

        return (
            <div style={[{ width: '100%' }]}>
                {this.renderHeader()}
                {rows}
            </div>
        )
    }
}

const styles = {
    flexify: {
        display: 'flex',
        flexDirection: 'row',
    },
    column: {
        flexGrow: 0,
        flexShrink: 0,
        verticalAlign: 'top',
    },
    label: {
        fontSize: '8px',
        position: 'absolute',
        top: '23px',
        width: '100%',
        fontWeight: '600'
    }
}

Apvs.propTypes = propTypes

Apvs.defaultProps = defaultProps

export default Radium(Apvs)


// WEBPACK FOOTER //
// ./src/App/APV/spreadsheets/apvs.js